import { useEffect, useState } from "react";

export const useScrollTop = () => {
    const [scrollPosition, setScrollPosition] = useState<number>(0);

    useEffect(() => {
        const setScroll = () => setScrollPosition(window.pageYOffset);
        window.addEventListener("scroll", setScroll);

        return () => {
            window.removeEventListener("scroll", setScroll);
        };
    }, []);

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return { scrollPosition, scrollTop };
};
